import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { getFolders } from '../api';

const styles = {
  container: {
    bgcolor: '#ecf1f4',
    height: '30px',
    fontWeight: '600',
    fontSize: '16px',
    my: 2,
    py: 1,
    px: 2,
    cursor: 'pointer',
    alignItems: 'center',
    borderRadius: '4px',
    border: '2px solid transparent',
    '&: hover': {
      border: '2px solid transparent',
      background:
        'linear-gradient(#fff, #fff) padding-box, linear-gradient(to left, #82E600, #49B487, #0080A7) border-box',
    },
  },
};

const Folder = props => {
  const {
    id,
    title,
    treeMediaCount,
    setData,
    setError,
    setLoading,
    setInitialData,
    setBreadCrumb,
    setSelectedFilters,
  } = props;

  const handleClick = useCallback(() => {
    setLoading(true);
    setError('');

    getFolders(id)
      .then(response => {
        setData(response.data);
        setInitialData(response.data);
        setBreadCrumb(prev => [...prev, { id, title }]);
        setSelectedFilters([]);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [id, setBreadCrumb, setData, setError, setInitialData, setLoading, setSelectedFilters, title]);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      onClick={handleClick}
      sx={styles.container}
    >
      <Box>{title}</Box>
      <Chip label={treeMediaCount} color="secondary" />
    </Stack>
  );
};

export default Folder;
